export default __webpack_public_path__ + "imgs/like-false.b00967356831f3bdc7c4529dc420ee5e.svg";